/*
 * O contato do comercial, num lugar só.
 *
 * O número e a frase estavam escritos em duas telas — o bloqueio por licença e
 * a apresentação do conector. Trocar o número do comercial exigia lembrar das
 * duas, e esquecer uma deixava metade do painel apontando para o número velho.
 */
const FONE_COMERCIAL = '5551984568586';

/**
 * O endereço do WhatsApp do comercial, já com a mensagem do módulo.
 *
 * @param {string} modulo   Nome do módulo, como o usuário o vê.
 * @param {string} mensagem Texto próprio, quando o conector traz um.
 */
function linkWhatsappComercial(modulo, mensagem) {
  const texto = mensagem
    || `Olá, tudo bem? Tenho interesse em conhecer mais sobre o módulo ${modulo || 'este módulo'}`;

  return `https://wa.me/${FONE_COMERCIAL}?text=${encodeURIComponent(texto)}`;
}

export { FONE_COMERCIAL, linkWhatsappComercial };
